import { useOutletContext } from "react-router-dom";
import type { Group, User } from "../lib/types";

export type AppOutletContext = {
  group: Group;
  user: User;
  onBlockedGroupAccess: (groupId: string) => void;
};

export function useAppOutletContext() {
  return useOutletContext<AppOutletContext>();
}
